export default "__VITE_ASSET__BxQcw9UX__"